import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {SettingsDependencies} from '../dependencies';
import {keys} from './keys';

export type GetProfileQueryDependencies = Pick<SettingsDependencies, 'controllers'>;

export const getProfileQuery = ({controllers}: GetProfileQueryDependencies) =>
  queryOptions({
    queryKey: keys.profile(),
    queryFn: () => controllers.settingsController.getProfile().then(unwrap),
  });
